var _rect, _rect2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.49146,
    width: 14.5,
    height: 14.5,
    rx: 3.25,
    fill: "#1F2024"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.49146,
    width: 14.5,
    height: 14.5,
    rx: 3.25,
    stroke: "#1F2024",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_802_4046",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 10,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7949 5.65892C13.0713 5.94078 13.0673 6.39369 12.7858 6.67052L6.83102 12.5279L3.21377 8.96984C2.93234 8.69301 2.92826 8.2401 3.20467 7.95823C3.48108 7.67637 3.93331 7.67229 4.21474 7.94912L6.83102 10.5226L11.7849 5.64981C12.0663 5.37298 12.5185 5.37706 12.7949 5.65892Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_802_4046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.00024,
    y: 3.74146,
    width: 9.99961,
    height: 9.99961,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.b32c17afc5013217c80a50071ed0ba34.svg";
export { ForwardRef as ReactComponent };